import { render, staticRenderFns } from "./locationTestC.vue?vue&type=template&id=31ba85f6&scoped=true&"
import script from "./locationTestC.vue?vue&type=script&lang=js&"
export * from "./locationTestC.vue?vue&type=script&lang=js&"
import style0 from "./locationTestC.vue?vue&type=style&index=0&id=31ba85f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ba85f6",
  null
  
)

export default component.exports